import { app } from '../app.module'
app.controller('EventCtrl', ($scope, $rootScope, $state, Restangular, EventService, $mdDialog) => {
  // アクセスのフラグをチェックして、フラグがない場合は、ブランドにリダイレクトする
  if ($rootScope.flgArchive === false) {
    $state.go('brand')
  }
  // 画面遷移時に、初期化処理を行う
  initProcess()

  // 月が選択された場合は、イベントデータのフィルタリングを行う
  $scope.$on('selectMonth', (event: {}, selectedMonth: number) => {
    $scope.selectedMonth = selectedMonth
    // フィルターを変更する
    changeFilter()
  })

  // イベントの新規登録、編集、削除が完了した場合は、データをリロードする
  $rootScope.$on('changeEventData', () => {
    initProcess()
  })

  // イベント編集モーダルを呼び出す
  $scope.showEditEventModal = function (eventId: number) {
    const template = `<edit-event-modal event-id=${eventId}></edit-event-modal>`
    $mdDialog.show({
      template: template,
      clickOutsideToClose: true,
    })
  }

  // 投稿一覧モーダルを呼び出す
  $scope.showPostListModal = function (sortNo: number) {
    // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
    const modalScope: {
      getOptions: {
        startEndDate: {
          startDate: number
          endDate: number
        }
        categoryFilter: {}
        subCategoryFilter: {}
        accountFilter: {}
        postTypeFilter: {}
        messageFilter: {}
        tagFilter: {}
        accountTagFilter: {}
        hashtagFilter: {}
        followerFilter: {}
        inFilter: {}
        favoriteFilter: {}
        groupId: number
        isPro: boolean
        userId: number
        accountId: number
        accountGlobalFilter: boolean
        eventTagFilter: string
      }
      eventName: string
    } = $rootScope.$new()

    // イベントは例外として過去3年分の投稿を表示する
    const startDate = moment().startOf('month').subtract(3, 'years').unix()
    const endDate = moment().unix()

    modalScope.getOptions = {
      startEndDate: {
        startDate: startDate,
        endDate: endDate,
      },
      // メインカテゴリ
      categoryFilter: null,
      // サブカテゴリ
      subCategoryFilter: null,
      // 検索するアカウント
      accountFilter: null,
      // 投稿タイプ
      postTypeFilter: null,
      // キーワード
      messageFilter: null,
      // 検索するタグ
      tagFilter: null,
      // アカウントタグ
      accountTagFilter: null,
      // 検索するハッシュタグ
      hashtagFilter: null,
      // フォロワー数
      followerFilter: null,
      // instagramフィルタ
      inFilter: null,
      // お気に入り
      favoriteFilter: null,
      groupId: $rootScope.groupId,
      // グループの契約プランがProか否か
      isPro: $rootScope.isPro,
      userId: $rootScope.userId,
      accountId: null,
      accountGlobalFilter: null,
      eventTagFilter: $scope.sortEvents[sortNo].tagIds,
    }
    modalScope.eventName = $scope.sortEvents[sortNo].eventName

    $mdDialog.show({
      template: require('../components/event-post-list-modal/event-post-list-modal.pug')(),
      scope: modalScope,
      clickOutsideToClose: true,
    })
  }

  /**
   * キーワードの変更イベント
   * @param {string} keyword キーワード
   */
  $scope.changeKeywordFilter = (keyword: string) => {
    if ($scope.keyword === keyword) {
      return
    }
    $scope.keyword = keyword
    // フィルターを変更する
    changeFilter()
  }

  /**
   * イベントデータを取得し、スコープにセットする
   */
  function initProcess() {
    $scope.isLoading = true
    $scope.selected = []
    $scope.events = []
    $scope.sortEvents = []
    $scope.selectedMonth = null
    $scope.keyword = null

    // 画面遷移時にイベントデータを取得する
    Restangular.all('event/getAllEvent')
      .getList()
      .then((response) => {
        if (response[0].data !== null) {
          $scope.events = response[0].data

          // viewに表示用の日付を加える
          $scope.events.forEach((event, index) => {
            $scope.events[index].displayDate = EventService.Common.addDisplayDate(event.date)
          })

          $scope.sortEvents = $scope.events
        }
        $scope.isLoading = false
      })
  }

  /**
   * フィルターの変更
   */
  function changeFilter() {
    $scope.sortEvents = EventService.Common.filterEvents(
      $scope.events,
      $scope.selectedMonth,
      $scope.keyword
    )
  }
})
